export const qualityData = {
  banner: {
    image: "/images/qc-banner2.jpg",
    alt: "Quality",
  },
  breadcrumb: [
    { label: "HOME", href: "/" },
    { label: "QUALITY", href: "/quality" },
  ],
  pageTitle: "Quality",
  qualityAssurance: {
    title: "Quality Assurance",
    paragraphs: [
      "Modepro's commitment to quality  is demonstarted through our adherance to industry leading standards. Oure quality systems align with the guidelines set forth by ICH Q7A, ensuring robust quality management throughout our operations. To ensure the effectiveness and compliance of our Quality Management Systems (QMS), we undergo regular audits conducted by multinational pharmaceutical companies. These audits serve as a validation of our commitment to cGMP (current Good Manufacturing Practices) requirements, reinforcing our reputation as a reliable and compliant partner in the pharmaceutical industry.",
      "Our company was successfully audited by USFDA during August, 2022.",
    ],
  },
  qualityControl: {
    title: "Quality Control",
    description:
      "Well-equipped  laboratories performing comprehensive tests for the finished products, WIP, raw  materials, equipment cleaning in compliance to ICH Q7 guidelines, In-house  test methods and customer's requirements.",
  },
  equipment: {
    title: "Quality Control Lab is equipped with:",
    items: [
      "HPLCs",
      "GC with Head Space",
      "UV Spectrophotometer",
      "FTIR Spectrophotometer",
      "Polarimeter",
      "Potentiometric Titrator",
      "Karl-Fischer Titrator",
      "pH Meter",
      "Conductivity Meter",
      "Analytical Balances",
    ],
  },
  images: [
    {
      src: "/images/MIPL 1.JPG",
      alt: "Quality Lab",
    },
    {
      src: "/images/MIPL 2.JPG",
      alt: "Quality Lab",
    },
    {
      src: "/images/MIPL 3.jpg",
      alt: "Quality Lab",
    },
    {
      src: "/images/MIPL 10.jpg",
      alt: "Quality Lab",
    },
  ],
};
